import { Filter } from '../../../../models/filter';
import { RecordResult } from '../../../../models/record-result';
import { YoutubeResponse } from '../../../../models/youtube-response';

export interface Search {
  id?: number;
  userId: string;
  total: number;
  query: string;
  searchDate: Date;
  facets: string;
  searchTerms?: SearchTerm[];
  filters?: Partial<Filter>[];
  collectionId: string | null;
  careerPlanLevelId: string | null;
  challengeId: string | null;
}

export enum SearchCriteriaField {
  ALL = 'allfields_txt',
  AUTHOR = 'author',
  TITLE = 'title',
  PUBLISHER = 'publisher',
  SUBJECT = 'subject'
}

export interface SearchTerm {
  term: string;
  label?: string;
  field?: string;
  icon?: string;
}

export interface SearchOrder {
  field: string;
  order: string;
  key: string;
  accessibilityKey: string;
}

export interface SearchResult {
  otkRecords: RecordResult;
  youtube: YoutubeResponse;
}

export interface SearchCriteria {
  field: string;
  key: string;
  icon: string;
}

export interface AvailabilityItem {
  key?: string;
  value: number;
  field: string;
}

export class AvailabilityFilter {
  total: AvailabilityItem;
  available: AvailabilityItem;

  constructor(filter: Filter) {
    filter.values.forEach((v) => {
      const value = v.value as number;

      if (v.name === 'Total') {
        this.total = { key: 'general.total', value: value, field: v.name };
      } else {
        this.available = {
          key: 'general.available',
          value: value,
          field: v.name,
        };
      }
    });
  }
}

export type ViewMode = 'GRID' | 'LIST';
